<template>
  <div v-if="!currentUser">
    <form @submit.prevent="login">
      <input type="email" class="form-control mb-3" v-model="email" placeholder="email" />
      <input type="password" class="form-control mb-3" v-model="password" placeholder="password" />
      <button type="submit" class="btn btn-primary w-100">Войти</button>
    </form>
  </div>
  <div v-else>
    <form action="" class="mb-5 pb-5" @submit.prevent="addWork">
      <input type="text" class="form-control mb-3" v-model="work.title" placeholder="Заголовок" />
      <input type="text" class="form-control mb-3" v-model="work.description" placeholder="Описание" />
      <input type="text" class="form-control mb-3" v-model="work.path" placeholder="Ссылка" />
      <select class="form-control mb-3" v-model="work.group">
        <option value="vue">Vue</option>
        <option value="react">React</option>
        <option value="site">Site</option>
        <option value="email">Email</option>
      </select>
      <input class="mb-3" type="file" ref="inputFile" @change="e => sendFile(e)" accept="image/png, image/jpeg" />
      <button type="submit" class="btn btn-primary w-100">Добавить</button>
    </form>
    <button type="submit" class="btn btn-danger" @click="logout">Выйти</button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import firebase from 'firebase/app';
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'Admin',
  data: () => ({
    email: '',
    password: '',
    work: {
      title: '',
      description: '',
      path: '',
      image: '',
      group: 'vue'
    }
  }),
  computed: {
    ...mapGetters('auth', ['currentUser'])
  },
  methods: {
    async login() {
      await this.$store.dispatch('auth/login', { email: this.email, password: this.password });
    },
    async logout() {
      await this.$store.dispatch('auth/logout');
      this.$router.push('/');
    },
    async addWork() {
      await this.$store.dispatch('works/addWork', this.work);
      this.work.title = '';
      this.work.description = '';
      this.work.path = '';
      this.work.image = '';
      this.work.group = 'vue';
      this.$refs.inputFile.value = null;
    },
    async sendFile(e) {
      const id = uuidv4();
      const uploadTask = firebase
        .storage()
        .ref()
        .child(id)
        .put(e.target.files[0], e.target.files[0].type);

      uploadTask.on(
        'state_changed',
        snapshot => {
          console.log((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        },
        error => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;

          uploadTask.snapshot.ref.getDownloadURL().then(async url => {
            this.work.image = url;
          });
        }
      );
    }
  }
};
</script>
